<div class="loginNewPage">
  <!-- <div >Login Page Works!</div> -->
  <div id="overlaySpinner" style="display:none;">
    <div class="spinner"></div>
    <br />
    Loading...
  </div>
  <!-- <div>
    <h2>{{ "WorkspaceName" | translate }}</h2>
    <label>
      {{ "HOME.SELECT" | translate }}
      <select #langSelect (change)="translate.use(langSelect.value)">
        <option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === translate.currentLang">
          {{ lang }}
        </option>
      </select>
    </label>
  </div> -->
  <div class="loginLeft">
    <div class="logInParts">
      <div class="row sideLoginPart">
        <div class="col col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 title">
          <img class="logo" src="./assets/images/stag_logo.png" alt="logo">
        </div>
      </div>
      <div class="sideLoginPart topSignIn">
        <div class="row full-width leftPanelTop card  p-3 mb-2 minht100per formDiv registerForm">
          <form novalidate (ngSubmit)="registerFormSubmit(register)" method="post" id="login-form" class="form-group">
            <h1 class="form-header title text-align-center text-color-white cursorArrow">{{ 'register' | translate }}</h1>
            <div height="16px" class="form-gap-div"></div>
            <div class="form-element">
              <!-- <label for="firstname" class="form-label">{{'registerFirstName'|translate}}</label> -->
              <div class="form-element-input">
                <input type="text" id="firstname" name="firstname" class="form-input-feild" value=""
                  [(ngModel)]="register.firstname" [placeholder]="'registerFirstName'|translate" required>
              </div>
            </div>
            <div class="form-element">
              <!-- <label for="lastname" class="form-label">{{'registerLastName'|translate}}</label> -->
              <div class="form-element-input">
                <input type="text" id="lastname" name="lastname" class="form-input-feild" value=""
                  [(ngModel)]="register.lastname" [placeholder]="'registerLastName'|translate" required>
              </div>
            </div>

            <div class="form-element" id="emailInputField">
              <!-- <label for="email" class="form-label">{{'registerEmail'|translate}}</label> -->
              <div class="form-element-input">
                <input type="text" id="email" name="email" class="form-input-feild" value=""
                  [(ngModel)]="register.emailId" [placeholder]="'registerEmail'|translate" required>
              </div>
            </div>
            <div class="form-element">
              <!-- <label for="email" class="form-label">{{'registerUsername'|translate}}</label> -->
              <div class="form-element-input">
                <input type="text" id="username" name="username" class="form-input-feild" value=""
                  [(ngModel)]="register.username" [placeholder]="'registerUsername'|translate" required>
              </div>
            </div>
            <div class="form-element" id="orgInputField">
              <!-- <label for="organization" class="form-label">{{'registerOrganization'|translate}}</label> -->
              <div class="form-element-input">
                <input type="text" id="organization" name="organization" class="form-input-feild" value=""
                  [(ngModel)]="register.organization" [placeholder]="'registerOrganization'|translate"
                  [disabled]='isOrgDisabled' required>
              </div>
            </div>
            <div class="form-element">
              <!-- <label for="password" class="form-label">{{'registerPassword'|translate}}</label> -->
              <div class="form-element-input">
                <input type="password" id="password" name="password" class="form-input-feild" value=""
                  [(ngModel)]="register.password" [placeholder]="'registerPassword'|translate" required>
              </div>
            </div>
            <div class="form-element">
              <!-- <label for="cpassword" class="form-label">{{'registerConPassword'|translate}}</label> -->
              <div class="form-element-input">
                <input type="password" id="cpassword" name="cpassword" class="form-input-feild" value=""
                  [(ngModel)]="register.confirmPassword" [placeholder]="'registerConPassword'|translate" required>
              </div>
            </div>
            <!-- <div class="form-element">
              <div class="form-element-input">
                <div class="row">
                  <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                    <img src="./assets/images/default-avatar-male.png" class="profileImage" />
                  </div>
                  <div class="col-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 profilePicSelection">
                    <i class="fa fa-camera" id="chooseFile"></i>
                    <span class="name">Select picture</span>
                    <input type="file" id="profilepic" name="profilepic" class="form-input-feild typeFileInput" value=""
                      [(ngModel)]="register.profile" [placeholder]={{'registerProfile'|translate}}>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="form-element">
              <div class="col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 pl-0 pr-0">
                <button type="submit" [ngClass]="{ dis: disRegisterBtn == true }"
                  (ngSubmit)="registerFormSubmit(register)" id="login-form-submit" class="form-submit-button">{{
                  'register' | translate }}</button>
              </div>
            </div>
            <div class="form-account text-color-white">
              <a routerLink="/login" class="form-account-options">
                <<{{ 'backToLogin' | translate }} </a>
                  <a data-toggle="modal" data-target="#resendEmailLinkModal"
                    class="form-account-options align_right">{{'resendVerifyLink'|translate}}</a>
            </div>
            <div id="snackbar">
              <div class="text-message">{{toastMsg}}</div>
            </div>
          </form>
        </div>
      </div>

      <div class="sideLoginPart">
        <div class="login-footer">
          <a href="" class="form-account-options">{{ 'termsOfService' | translate }}</a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">{{ 'privacyPolicy' | translate }}</a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">{{ 'security' | translate }}</a>
        </div>
        <div class="row">
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-align-center">
            <!-- <select #langSelect (change)="translate.use(langSelect.value);updateLanguage(langSelect.value)">
              <option *ngFor="let lang of languages" [value]="lang.short"
                [selected]="lang.short === translate.currentLang">
                {{ lang.fullform }}
              </option>
            </select> -->
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The email verification resend Modal -->
  <div class="modal fade" id="resendEmailLinkModal" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal" (click)="resendEmailClearFn()">&times;</button>
              </div>

              <div class="col col-9 col-md-9 col-lg-9 col-sm-9 col-xs-9">
                <div class="form-element mb-0">
                  <label for="lastname"
                    class="form-label marginbottom6px displayNone">{{'group.email'|translate}}</label>
                  <div class="form-element-input">
                    <input type="text" id="resendEmailID" name="resendEmailID"
                      class="form-input-feild input-sm menuItemsClrBlack" value="" [(ngModel)]="resendEmailID"
                      [placeholder]="'group.userEmail'|translate" required>
                  </div>
                </div>
                <span style="margin-left: 20% !important;">{{toastMsgResendVerify}}</span>
              </div>
              <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-3">
                <div class="form-element">
                  <!-- <label class="form-label"></label> -->
                  <div class="form-element-input inviteFormElement">
                    <button type="button" class="btn btn-secondary userInvitetoOrgBtn actionbutton pl-0 pr-0"
                      (click)="resendEmailVerifyLink(resendEmailID)">{{'settings.sendBtn'|translate}}</button>
                    <!-- ;closeNav() -->
                  </div>
                </div>
              </div>
            

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="loginSecondPart">
    <div class="logInParts">
      <div class="loginRightSide">
        <div class="centerImage">
          <img src="../assets/images/1.png">
        </div>
      </div>
    </div>
  </div>
</div>